import { z } from "zod";
export var contentGroupTypeSchema = z.union([z.literal("None"), z.literal("Role"), z.literal("UserDefined")]);
export var metadataObjectSchema = z.object({
    valueType: z.string().optional().nullable(),
    value: z.string().optional().nullable(),
    metadataElementId: z.string(),
    valueId: z.string().optional().nullable()
});
export var stateSchema = z.object({
    name: z.string(),
    state: z.number(),
    canTransitionTo: z.array(z.number())
});
export var stateSettingsSchema = z.object({
    startState: z.number(),
    endState: z.number(),
    states: z.array(stateSchema)
});
export var filterOptionSchema = z.object({
    filter: z.string()
});
export var contentGroupSettingsSchema = z.object({
    contentGroupTypeEnum: contentGroupTypeSchema,
    contentGroup: z.string()
});
export var workflowSchema = z.object({
    id: z.string(),
    name: z.string(),
    workflowTemplateId: z.string(),
    issueTemplateId: z.string(),
    metadata: z.array(metadataObjectSchema),
    stateSettings: stateSettingsSchema,
    filterOptions: z.array(filterOptionSchema),
    contentGroupSettings: contentGroupSettingsSchema
});
//# sourceMappingURL=Issue.zod.js.map